import { LOCAL_STORAGE_STORE } from '@/store'
import { MutationPayload, Store } from 'vuex'

export default function createLocalStoragePlugin(): (
  store: Store<any>,
) => void {
  return (store: Store<any>) => {
    store.subscribe((mutation: MutationPayload, state) => {
      // Exclude unwanted modules from local storage
      const {
        betBuilderModule,
        voiceModule,
        composeModule,
        ...newState
      } = state

      console.info('Store updated. Saving state to localStorage.')
      localStorage.setItem(LOCAL_STORAGE_STORE, JSON.stringify(newState))
    })
  }
}
